export default __webpack_public_path__ + "static/media/element_24.72751f8a.jpg";